import React, { useEffect, useState } from "react";
import ComponentSousTitle from "../../layout/ComponentSousTitle";
import ComponentOrgUnit from "../orgunit/ComponentOrgUnit";
import ComponentEspace from "../colidee/ComponentEspace";
import { CardGroup } from "react-bootstrap";
import { MdAddCircleOutline, MdRemoveCircleOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { selectInGouvernanceFilters } from "../../../redux/ReduxFilter";

const ComponentGovernanceViewMacro = (props) => {
  const { espaces, processes } = props;
  const [limit, setLimit] = useState([]);
  const [nbrAfficheBase] = useState(0);
  const _selectInGouvernanceFilters = useSelector(selectInGouvernanceFilters);

  const toggleAll = (nbrProcess, toggle) => {
    const newLimit = [...limit];
    for (let i = 0; i < nbrProcess; i++) {
      if (toggle) newLimit[i] = 10000;
      else newLimit[i] = 0;
    }
    setLimit(newLimit);
  };

  const toggle = (e) => {
    const newLimit = [...limit];

    if (newLimit[e] === nbrAfficheBase) {
      newLimit[e] = 10000;
    } else {
      newLimit[e] = nbrAfficheBase;
    }
    setLimit(newLimit);
  };

  const afficheSeeMore = (
    nbrEspacesTotal,
    nbrOrgUnitRituel,
    nbrOrgUnitTempsCollectif,
    nbrOrgUnitRole,
    nbrOrgUnitPartiePrenante
  ) => {
    if (
      (nbrEspacesTotal > nbrAfficheBase &&
        (_selectInGouvernanceFilters.espace || _selectInGouvernanceFilters.all)) ||
      (nbrOrgUnitRituel > nbrAfficheBase &&
        (_selectInGouvernanceFilters.rituel || _selectInGouvernanceFilters.all)) ||
      (nbrOrgUnitTempsCollectif > nbrAfficheBase &&
        (_selectInGouvernanceFilters.tempscollectif || _selectInGouvernanceFilters.all)) ||
      (nbrOrgUnitRole > nbrAfficheBase && _selectInGouvernanceFilters.role) ||
      (nbrOrgUnitPartiePrenante > nbrAfficheBase &&
        (_selectInGouvernanceFilters.partieprenante || _selectInGouvernanceFilters.all))
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    const allLimit = [];
    processes.map((process, indexProcess) => (allLimit[indexProcess] = nbrAfficheBase));
    setLimit(allLimit);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!_selectInGouvernanceFilters.all) {
      toggleAll(processes.length, 1);
    } else {
      toggleAll(processes.length, 0);
    }
  }, [_selectInGouvernanceFilters.all]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {processes.map((process, indexProcess) => (
        <React.Fragment key={"process_" + indexProcess}>
          <ComponentSousTitle
            nom={process.nom}
            popupInfo={process.description}
            overflowID={"overflow" + indexProcess}
            idTagTixme={process._id}
            titleHref={"/processes/" + process._id}
          />
          <CardGroup
            className="overflowContent align-items-stretch mb-5"
            id={"overflow" + indexProcess}
          >
            {(_selectInGouvernanceFilters.espace || _selectInGouvernanceFilters.all) &&
              espaces
                .filter((espace) => process.espaces.includes(espace.id_plateforme))
                .map((espace, indexEspace) => (
                  <React.Fragment key={"espace_" + indexProcess + "_" + indexEspace}>
                    {indexEspace < limit[indexProcess] + 3 && (
                      <ComponentEspace espaceObject={espace} />
                    )}
                  </React.Fragment>
                ))}

            {/* PINNED */}
            {(_selectInGouvernanceFilters.rituel || _selectInGouvernanceFilters.all) &&
              process.orgunits
                .filter(
                  (orgunit) =>
                    orgunit.type === "Rituel" &&
                    process.orgunitsPinned.includes(orgunit._id) &&
                    !orgunit.enSommeil
                )
                .map((orgunit, indexOrgUnit) => (
                  <React.Fragment key={"orgunitPinned_" + indexProcess + "_" + indexOrgUnit}>
                    <ComponentOrgUnit
                      orgunitObject={orgunit}
                      isPinned={process.orgunitsPinned.includes(orgunit._id)}
                    />
                  </React.Fragment>
                ))}

            {(_selectInGouvernanceFilters.tempscollectif || _selectInGouvernanceFilters.all) &&
              process.orgunits
                .filter(
                  (orgunit) =>
                    orgunit.type === "Temps collectif" &&
                    process.orgunitsPinned.includes(orgunit._id) &&
                    !orgunit.enSommeil
                )
                .map((orgunit, indexOrgUnit) => (
                  <React.Fragment key={"orgunitPinned_" + indexProcess + "_" + indexOrgUnit}>
                    <ComponentOrgUnit
                      orgunitObject={orgunit}
                      isPinned={process.orgunitsPinned.includes(orgunit._id)}
                    />
                  </React.Fragment>
                ))}

            {(_selectInGouvernanceFilters.role || _selectInGouvernanceFilters.all) &&
              process.orgunits
                .filter(
                  (orgunit) =>
                    orgunit.type === "Rôle" &&
                    process.orgunitsPinned.includes(orgunit._id) &&
                    !orgunit.enSommeil
                )
                .map((orgunit, indexOrgUnit) => (
                  <React.Fragment key={"orgunitPinned_" + indexProcess + "_" + indexOrgUnit}>
                    <ComponentOrgUnit
                      orgunitObject={orgunit}
                      isPinned={process.orgunitsPinned.includes(orgunit._id)}
                    />
                  </React.Fragment>
                ))}

            {(_selectInGouvernanceFilters.partieprenante || _selectInGouvernanceFilters.all) &&
              process.orgunits
                .filter(
                  (orgunit) =>
                    orgunit.type === "Partie prenante" &&
                    process.orgunitsPinned.includes(orgunit._id) &&
                    !orgunit.enSommeil
                )
                .map((orgunit, indexOrgUnit) => (
                  <React.Fragment key={"orgunitPinned_" + indexProcess + "_" + indexOrgUnit}>
                    <ComponentOrgUnit
                      orgunitObject={orgunit}
                      isPinned={process.orgunitsPinned.includes(orgunit._id)}
                    />
                  </React.Fragment>
                ))}
            {/* FIN PINNED */}

            {(_selectInGouvernanceFilters.rituel || _selectInGouvernanceFilters.all) &&
              process.orgunits
                .filter(
                  (orgunit) =>
                    orgunit.type === "Rituel" &&
                    !process.orgunitsPinned.includes(orgunit._id) &&
                    !orgunit.enSommeil
                )
                .map((orgunit, indexOrgUnit) => (
                  <React.Fragment key={"orgunitRituel_" + indexProcess + "_" + indexOrgUnit}>
                    {indexOrgUnit < limit[indexProcess] && (
                      <ComponentOrgUnit orgunitObject={orgunit} />
                    )}
                  </React.Fragment>
                ))}

            {(_selectInGouvernanceFilters.tempscollectif || _selectInGouvernanceFilters.all) &&
              process.orgunits
                .filter(
                  (orgunit) =>
                    orgunit.type === "Temps collectif" &&
                    !process.orgunitsPinned.includes(orgunit._id) &&
                    !orgunit.enSommeil
                )
                .map((orgunit, indexOrgUnit) => (
                  <React.Fragment
                    key={"orgunitTempsCollectif_" + indexProcess + "_" + indexOrgUnit}
                  >
                    {indexOrgUnit < limit[indexProcess] && (
                      <ComponentOrgUnit orgunitObject={orgunit} />
                    )}
                  </React.Fragment>
                ))}

            {(_selectInGouvernanceFilters.role || _selectInGouvernanceFilters.all) &&
              process.orgunits
                .filter(
                  (orgunit) =>
                    orgunit.type === "Rôle" &&
                    !process.orgunitsPinned.includes(orgunit._id) &&
                    !orgunit.enSommeil
                )
                .map((orgunit, indexOrgUnit) => (
                  <React.Fragment key={"orgunitRole_" + indexProcess + "_" + indexOrgUnit}>
                    {indexOrgUnit < limit[indexProcess] && (
                      <ComponentOrgUnit orgunitObject={orgunit} />
                    )}
                  </React.Fragment>
                ))}

            {(_selectInGouvernanceFilters.partieprenante || _selectInGouvernanceFilters.all) &&
              process.orgunits
                .filter(
                  (orgunit) =>
                    orgunit.type === "Partie prenante" &&
                    !process.orgunitsPinned.includes(orgunit._id)
                )
                .map((orgunit, indexOrgUnit) => (
                  <React.Fragment
                    key={"orgunitPartiePrenante_" + indexProcess + "_" + indexOrgUnit}
                  >
                    {indexOrgUnit < limit[indexProcess] && (
                      <ComponentOrgUnit orgunitObject={orgunit} />
                    )}
                  </React.Fragment>
                ))}
            <div className="seeMoreMacroProcess d-flex align-items-center justify-content-center m-2">
              {limit[indexProcess] === nbrAfficheBase &&
                afficheSeeMore(
                  espaces.filter((espace) => process.espaces.includes(espace.id_plateforme)).length,
                  process.orgunits.filter((orgunit) => orgunit.type === "Rituel").length,
                  process.orgunits.filter((orgunit) => orgunit.type === "Temps collectif").length,
                  process.orgunits.filter((orgunit) => orgunit.type === "Rôle").length,
                  process.orgunits.filter((orgunit) => orgunit.type === "Partie prenante").length
                ) && (
                  <MdAddCircleOutline
                    role="button"
                    size="2em"
                    onClick={(e) => toggle(indexProcess)}
                  />
                )}
              {limit[indexProcess] > nbrAfficheBase &&
                afficheSeeMore(
                  espaces.filter((espace) => process.espaces.includes(espace.id_plateforme)).length,
                  process.orgunits.filter((orgunit) => orgunit.type === "Rituel").length,
                  process.orgunits.filter((orgunit) => orgunit.type === "Temps collectif").length,
                  process.orgunits.filter((orgunit) => orgunit.type === "Rôle").length,
                  process.orgunits.filter((orgunit) => orgunit.type === "Partie prenante").length
                ) && (
                  <MdRemoveCircleOutline
                    role="button"
                    size="2em"
                    onClick={(e) => toggle(indexProcess)}
                  />
                )}
            </div>
          </CardGroup>
        </React.Fragment>
      ))}
    </>
  );
};

export default ComponentGovernanceViewMacro;
